/* Blackbeard · CRO: botón "Agregar" de recomendaciones del carrito (lleno y vacío).
   Delegado en document porque el drawer se re-renderiza completo con la Section Rendering API. */
(function () {
  if (window.bbCroLoaded) return;
  window.bbCroLoaded = true;

  document.addEventListener('click', async function (event) {
    const btn = event.target.closest('[data-bb-add]');
    if (!btn || btn.disabled) return;
    event.preventDefault();

    const label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Agregando…';

    const cartDrawer = document.querySelector('cart-drawer');
    const useDrawer = cartDrawer && typeof cartDrawer.renderContents === 'function' && !document.querySelector('cart-items');
    const sections = useDrawer ? cartDrawer.getSectionsToRender().map((s) => s.id) : [];

    const body = new FormData();
    body.append('id', btn.dataset.bbAdd);
    body.append('quantity', '1');
    if (sections.length) {
      body.append('sections', sections.join(','));
      body.append('sections_url', window.location.pathname);
    }

    try {
      const res = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: body,
      });
      const data = await res.json();
      if (data.status) throw new Error(data.description || 'error');
      if (useDrawer) {
        // Igual que product-form.js de Dawn: sin esto el drawer se queda en modo vacío.
        cartDrawer.classList.remove('is-empty');
        cartDrawer.renderContents(data);
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
    } catch (e) {
      btn.disabled = false;
      btn.textContent = label;
    }
  });
})();

/* Blackbeard · CRO: animación de la barra de progreso del carrito (snippets/bb-cart-progress.liquid).
   Dawn reemplaza el HTML del drawer en cada cambio, así que la barra nueva nace con su ancho final
   y la transición de CSS nunca se ve. Aquí la arrancamos desde el último % conocido (o desde 0 al
   abrir el drawer) y marcamos cuándo se cruza la meta para el "pop" del check.
   Sin este script la barra se muestra igual, solo que sin animar. */
(function () {
  if (window.bbProgressLoaded) return;
  window.bbProgressLoaded = true;

  const drawer = document.querySelector('cart-drawer');
  if (!drawer || !window.MutationObserver) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const current = () => drawer.querySelector('[data-bb-progress]');
  const pctOf = (el) => (el ? parseFloat(el.dataset.bbProgress) || 0 : 0);

  let lastEl = current();
  let lastPct = pctOf(lastEl);
  let animatedAt = 0;

  function animate(el, from) {
    const to = pctOf(el);
    const bar = el.querySelector('.bb-progress__bar');
    lastPct = to;
    if (!bar || from === to || reduceMotion.matches) return;

    if (!bar.dataset.bbBound) {
      bar.dataset.bbBound = '1';
      // CartDrawer.open() espera un transitionend (el del panel) para atrapar el foco; que no sea el de la barra.
      bar.addEventListener('transitionend', (event) => event.stopPropagation());
    }

    bar.style.transition = 'none';
    bar.style.width = from + '%';
    void bar.offsetWidth; // reflow: el navegador registra el ancho inicial antes de animar
    bar.style.transition = '';
    bar.style.width = '';
    animatedAt = Date.now();

    if (from < 100 && el.classList.contains('bb-progress--done')) {
      el.classList.remove('bb-progress--celebrate');
      void el.offsetWidth; // reinicia la animación si ya estaba
      el.classList.add('bb-progress--celebrate');
    }
  }

  // El carrito cambió (agregar, cantidades, eliminar): animar desde el % anterior.
  new MutationObserver(() => {
    const el = current();
    if (el === lastEl) return;
    lastEl = el;
    if (el) animate(el, lastPct);
    else lastPct = 0; // carrito vacío: el siguiente producto arranca desde 0
  }).observe(drawer, { childList: true, subtree: true });

  // Se abrió el drawer desde el ícono: llenar desde 0. Si se abrió tras agregar, ya se animó arriba.
  new MutationObserver((records) => {
    const wasClosed = records.some((r) => !/(^|\s)active(\s|$)/.test(r.oldValue || ''));
    if (!wasClosed || !drawer.classList.contains('active')) return;
    const el = current();
    if (el && Date.now() - animatedAt > 600) animate(el, 0);
  }).observe(drawer, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
})();

/* Blackbeard · CRO: zona con scroll del drawer (.bb-drawer-scroll en snippets/cart-drawer.liquid).
   - Al cambiar cantidades Dawn re-renderiza .drawer__inner y el scroll volvería arriba: lo conservamos.
     Al agregar un producto (se re-renderiza todo #CartDrawer) o al abrir el drawer, empieza arriba.
   - Al desplegar "Instrucciones especiales del pedido" la lleva a la vista.
   - Pone bb-more-above / bb-more-below para las sombras que avisan que hay más contenido.
   - "Te podría interesar" asomado: mientras las tarjetas no se ven, el encabezado sticky lleva
     .is-peeking (miniaturas + "Ver") y al tocarlo baja hasta las recomendaciones. */
(function () {
  if (window.bbDrawerScrollLoaded) return;
  window.bbDrawerScrollLoaded = true;

  const drawer = document.querySelector('cart-drawer');
  if (!drawer || !window.MutationObserver) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const resizeObserver = window.ResizeObserver ? new ResizeObserver(() => updateEdges()) : null;
  let scroller = null;
  let inner = null;
  let savedTop = 0;

  function updateEdges() {
    if (!scroller) return;
    const max = scroller.scrollHeight - scroller.clientHeight;
    scroller.classList.toggle('bb-more-above', scroller.scrollTop > 2);
    scroller.classList.toggle('bb-more-below', max - scroller.scrollTop > 2);

    const head = scroller.querySelector('.bb-upsell__head');
    const upsell = scroller.querySelector('.bb-upsell');
    const peeking = !!(head && upsell) &&
      upsell.getBoundingClientRect().top > scroller.getBoundingClientRect().bottom - 2;
    if (head) head.classList.toggle('is-peeking', peeking);
    scroller.classList.toggle('bb-peeking', peeking);
  }

  function sync() {
    const el = drawer.querySelector('.bb-drawer-scroll');
    if (el !== scroller) {
      const newInner = el ? el.closest('.drawer__inner') : null;
      if (el && newInner === inner) el.scrollTop = savedTop; // mismo panel: solo cambiaron cantidades
      scroller = el;
      inner = newInner;
      savedTop = el ? el.scrollTop : 0;
      if (resizeObserver) {
        resizeObserver.disconnect();
        if (el) [el, ...el.children].forEach((node) => resizeObserver.observe(node));
      }
    }
    updateEdges();
  }

  new MutationObserver(sync).observe(drawer, { childList: true, subtree: true });

  // Al abrir el drawer desde el ícono, mostrar desde arriba (barra + primeros productos).
  new MutationObserver((records) => {
    const wasClosed = records.some((r) => !/(^|\s)active(\s|$)/.test(r.oldValue || ''));
    if (!wasClosed || !drawer.classList.contains('active') || !scroller) return;
    scroller.scrollTop = 0;
    savedTop = 0;
    updateEdges();
  }).observe(drawer, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });

  // scroll y toggle no burbujean: se escuchan en captura.
  drawer.addEventListener(
    'scroll',
    (event) => {
      if (event.target !== scroller) return;
      savedTop = scroller.scrollTop;
      updateEdges();
    },
    { capture: true, passive: true }
  );
  drawer.addEventListener(
    'toggle',
    (event) => {
      const note = event.target;
      if (!note.classList || !note.classList.contains('bb-cart-note') || !note.open) return;
      note.scrollIntoView({ block: 'nearest', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    },
    true
  );
  // Tocar "Te podría interesar" asomado: bajar hasta las tarjetas (sin agregar #hash a la URL).
  drawer.addEventListener('click', (event) => {
    const head = event.target.closest('.bb-upsell__head');
    if (!head || !scroller) return;
    event.preventDefault();
    const upsell = scroller.querySelector('.bb-upsell');
    if (upsell) upsell.scrollIntoView({ block: 'nearest', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
  });

  sync();
})();
